import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45bc7c2e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=45bc7c2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc7c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45bc7c2e')) {
      api.createRecord('45bc7c2e', component.options)
    } else {
      api.reload('45bc7c2e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=45bc7c2e&scoped=true", function () {
      api.rerender('45bc7c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hierarchicalCommissionAllocation/upgradeConfiguration/index.vue"
export default component.exports